import { __rest } from "tslib";
import vueCompat from '@tencent/vue-compat';
import { createDirective } from "../directives";
import { setMiddlewares } from "../middleware";
import { createReporter } from "../reporter";
let reporter;
export function useReporter() {
    return reporter;
}
const plugin = vueCompat.useWrap({
    install(Vue, options) {
        const { middlewares = [], useDirective = true } = options, params = __rest(options, ["middlewares", "useDirective"]);
        if (!middlewares.length) {
            throw new Error('middlewares can not be empty');
        }
        reporter = createReporter(params, middlewares);
        // 初始化中间件，用于处理指令逻辑
        setMiddlewares(middlewares);
        // 用于异步加载上报sdk场景，先初始化指令
        if (useDirective) {
            createDirective(Vue);
        }
        // eslint-disable-next-line
        Vue.prototype.$report = reporter;
    },
});
export default plugin;
